import ClientPassengerInterface from '../../interfaces/client/Passenger'

export default (flightId: string) => (passenger: ClientPassengerInterface) =>
  !passenger.checkedInOnFlights.includes(flightId)
